import { ApplicationInsightsService } from './services/application-insights.service';

export function initAll(applicationInsightsService: ApplicationInsightsService) {
  applicationInsightsService.init();

  return () => Promise.resolve();
}
